import { Injectable } from "@angular/core";
import { FileUploadActionES } from "@edp-models/ES/es-file-upload.model";
import { EdpResponseBody } from "@edp-models/response.model";
import { FileUploadServiceES } from "@edp-services/ES/file-upload.service";
import { EFileUploadActionsES } from "@edp-store/actions/ES/file-upload-es.actions";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { EMPTY } from "rxjs";
import { catchError, switchMap } from "rxjs/operators";


@Injectable()
export class FileUploadEffectsES {
    uploadFile$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(EFileUploadActionsES.UploadFile),
                switchMap((data: FileUploadActionES) => {
                    return this.fileUpload.uploadFile(data.payload).pipe(
                        switchMap((response: EdpResponseBody) => {
                            const file = response[0];
                            const payload = { ...data.payload, id: file.id, path: file.path, isLoading: false };
                            return [{ type: EFileUploadActionsES.SaveUploadedFile, payload }];
                        }),
                        catchError(() => EMPTY)
                    );
                })
            ),
        { dispatch: true }
    );

    constructor(private actions$: Actions, private fileUpload: FileUploadServiceES) {}
}
